<template>
  <div class="home">
    <div class="logo" />
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="scss">
.home {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo {
    background-image: url("../assets/logo_myrebeck_group.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    box-sizing: border-box;
    padding: 60px;
    height: 100%;
    width: 100%;
    max-width: 600px;
    max-height: 600px;
  }
}
</style>
